import type { FormData } from "../types";

interface ObjectivesSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
}

export function ObjectivesSection({
  formData,
  onFormChange,
}: ObjectivesSectionProps) {
  return (
    <div className="md:col-span-2">
      <label
        className="block text-sm font-medium mb-2"
        style={{ color: "var(--text-primary)" }}
      >
        Objetivos de Aprendizado
      </label>
      <textarea
        value={formData.objectives}
        onChange={(e) => onFormChange("objectives", e.target.value)}
        rows={3}
        className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 transition bg-(--input-bg)"
        style={{
          borderColor: "var(--border-color)",
          color: "var(--text-primary)",
        }}
        placeholder="Descreva o que os alunos devem aprender nesta aula..."
      />
    </div>
  );
}
